import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPageType } from 'services/tracking/gtm/gtm-data';
import PropTypes from 'prop-types';
import { trackUserPushes } from 'services/tracking';
import { USER_PUSHES } from 'constants/tracking';


class NotificationsBannerController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isImpressionAlreadyTracked: false,
    };
  }

  componentDidMount() {
    this.showNotificationsBanner();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.isDefaultPushNotificationsPermission) {
      this.showNotificationsBanner();
    }
  }

  showNotificationsBanner() {
    const { isImpressionAlreadyTracked } = this.state;
    if (this.canShowPushModal()) {
      if (!isImpressionAlreadyTracked) {
        this.setState({ isImpressionAlreadyTracked: true });
        trackUserPushes(USER_PUSHES.IMPRESSION, getPageType(window.location).toLowerCase());
      }
    }
  }

  canShowPushModal() {
    const { isPushNotificationsSubscribed, isShowingEstablishmentModal, isPushNotificationsSupported } = this.props;
    return !isPushNotificationsSubscribed && !isShowingEstablishmentModal && isPushNotificationsSupported;
  }

  render() {
    return <div className="notifications-banner-controller" />;
  }
}

NotificationsBannerController.defaultProps = {
  isDefaultPushNotificationsPermission: null,
  isShowingEstablishmentModal: null,
};

NotificationsBannerController.propTypes = {
  isDefaultPushNotificationsPermission: PropTypes.bool,
  isPushNotificationsSubscribed: PropTypes.bool.isRequired,
  isPushNotificationsSupported: PropTypes.bool.isRequired,
  isShowingEstablishmentModal: PropTypes.bool,
};

const mapStateToProps = state => ({
  isPushNotificationsSubscribed: state.appReducer.isPushNotificationsSubscribed,
  isPushNotificationsSupported: state.appReducer.notificationsSupported,
});

export default connect(mapStateToProps)(NotificationsBannerController);
